angular.module('impactx.MenuDirectives').controller('LogoCtrl', ['$workspace', '$redirect', LogoCtrl]);

function LogoCtrl($workspace, $redirect) {

    this.getLogo = function() {
        return $workspace.logoUrl;
    };

}